var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmallPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#6a7578",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M10 14.167v4.166M4 13h12v-1.29c0-.274-.09-.54-.257-.773a1.65 1.65 0 0 0-.694-.54l-1.526-.66a1.65 1.65 0 0 1-.694-.54 1.3 1.3 0 0 1-.258-.773v-3.49h.858c.454 0 .89-.155 1.212-.43s.502-.648.502-1.037c0-.39-.18-.762-.502-1.037A1.87 1.87 0 0 0 13.429 2H6.57c-.454 0-.89.155-1.212.43a1.37 1.37 0 0 0-.502 1.037c0 .389.18.762.502 1.037s.758.43 1.212.43h.858v3.49c0 .273-.09.54-.258.772s-.408.42-.694.54l-1.526.66a1.65 1.65 0 0 0-.694.541c-.168.232-.257.5-.257.772z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallPin);
export default __webpack_public_path__ + "static/media/small-pin.7f56d663a2c06f277643631505b51522.svg";
export { ForwardRef as ReactComponent };